export default "__VITE_ASSET__175788d6__"